import { locale, loadMessages } from "devextreme/localization";

/**
 * Initialize DevExtreme Italian localization
 *
 * This is the STANDARD and RECOMMENDED approach for DevExtreme localization:
 * 1. Import official Italian messages from DevExtreme
 * 2. Load them using loadMessages()
 * 3. Set the locale to "it"
 */
export const initializeLocalization = async () => {
  try {
    // The official DevExtreme way: import their Italian messages
    const itMessages = await import("devextreme/localization/messages/it.json");

    // Load the official messages
    loadMessages(itMessages.default || itMessages);

    // Set locale to Italian
    locale("it");

    console.log("✅ DevExtreme Italian localization loaded successfully");
  } catch (error) {
    console.warn(
      "⚠️ Could not load DevExtreme Italian messages, using locale-only fallback:",
      error
    );

    // Fallback: Just set the locale
    locale("it");
  }
};
